import {
    Log, LogLevel,
} from 'one-log';

import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';
import {
    format_one
} from 'one-util-date';
import logo from "./logo.png";
import { Disposition } from 'one-model-local';

// set up the logger
const log = new Log("ccw-app", [
    new BrowserLogger(),
], LogLevel.DEBUG);

loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
        } = options;

        /**
         * check for the log level config from settings and set default
         */
        const { logconfig, alertnotify,five9_callvariables, toaster_notification, compatible : { consolidated_api_invocation, panviva_sso },uisettings: {panviva_config}  } = settings;
        const { panviva_cvsearch,defaultcvsearch} = panviva_config;
        if (logconfig?.level === "INFO") {
            log.setlevel(LogLevel.INFO);
        } else if (logconfig?.level === "WARN") {
            log.setlevel(LogLevel.WARN);
        } else if (logconfig?.level === "ERROR") {
            log.setlevel(LogLevel.ERROR);
        } else {
            log.setlevel(LogLevel.DEBUG);
        }

        // logged in agent id
        const agentId = '';
        // adding ani
        const ani = '';
        let alertnotification = new AlertNotification(false, alertnotify?.url, {
        });
        if (alertnotify?.enable) {
            alertnotification = new AlertNotification(true, alertnotify?.url, {
                customer_name: alertnotify?.customer,
                server_id: alertnotify?.servername,
                app_type: "web"
            })
        }
        // enable user specific trace
        enableTrace(agentId, {
            log,
            settings,
        });
        const Notify = (message: any) => {
            let notify = new Notification("", {
                body : message,
                icon: resolver(logo)
                //timestamp: toaster_notification?.notification_time_duration
            });
            notify.onclick = (e) => {
                window.focus();
            }
            notify.onshow = function () {
                setTimeout(()=>{
                    notify.close();
                }, toaster_notification?.notification_time_duration);
            }
        }
        /**
         * When dashboard gets loaded ask for Notification Permission to user
         */
        if(Notification.permission === 'denied' || Notification.permission === 'default'){
            Notification.requestPermission().then(permission => {
                log.debug('Notification Permission ',permission);
            })
        }

        const server = new HAServer(
            settings['servers'],
            (url: string, error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        );

        const serverone = new HAServerOne(
            settings['servers'],
            (url: string, error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        );

        let interactionApi = window.Five9.CrmSdk.interactionApi();
        let crmApi = window.Five9.CrmSdk.crmApi();

        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            agentId,
            ani,
            settings,
            resolver,
            alertnotification,
            server,
            serverone,
            interactionApi,
        });

        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-web',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });

        
        console.log({ crmApi })
        crmApi.registerApi({
            saveLog: function (params: any) {
                console.log('saveLog')
                console.log({ params });
                const { interactionData: { callId, ani, dnis, agentName, agentExtension }, interactionLogData: { cavList }} = params
                const CallStartTime = cavList[cavList.findIndex((item:any) => item.name === 'start_timestamp')].value
                const CallEndTime = cavList[cavList.findIndex(item => item.name === 'end_timestamp')].value
                const callDuration = cavList[cavList.findIndex(item => item.name === 'length')].value
                const dispositionName = cavList[cavList.findIndex(item => item.name === 'disposition_name')].value
                let stateobj = store.getState();
                const selectedPatient = stateobj?.subjectstore?.selected;
                // Save Data to EPIC
                
                let info: object = {
                    agentName: agentName,
                    agentExtension: agentExtension,
                    patientName: `${selectedPatient?.firstname} ${selectedPatient?.lastname}`,
                    patientDOB: selectedPatient?.dob,
                    dispositionName
                }
                
                const data = {
                    callId,
                    ani,
                    dnis,
                    Lang: "en-us",
                    serverIP: five9_callvariables.serverIP,
                    CallStartTime: format_one(CallStartTime),
                    CallEndTime: format_one(CallEndTime),
                    callDuration,
                    others: info,
                    elements: []
                }
                
                store.dispatch({
                    type: "push-call-record",
                    payload: data,
                });
            },
            search: function (params: any) {
                console.log('search')
                console.log({ params });
            },
            enableClickToDial: function (params: any) {
                log.debug('Click To Dial', params);
                store.dispatch({
                    type: "store-five9-details",
                    payload: true
                });
                const { five9_callvariables: { organizationId, variables: { caller_sourceid } } } = settings;
                // To fetch Call Variables
                interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/orgs/${organizationId}/call_variables`, method: 'GET', payload: null }).then(function (result: any) {
                    // resolve handler
                    const { response } = result
                    const data = JSON.parse(response.replace('/', ''))
                    const sourceId = data.find(({ name, group }: { name: string, group: string }) => name === caller_sourceid.name && group === caller_sourceid.group)?.id

                    store.dispatch({
                        type: "store-five9-call-variables",
                        payload: {
                            sourceId
                        },
                    });
                    sessionStorage.setItem("five9_source_id", sourceId);
                    sessionStorage.setItem("five9_globalsearch", "true");
                }, function (error: any) {
                    // reject handler
                    log.debug('Call variables error ', error);
                });
                // To fetch userId of Five9 Agent
                interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/auth/metadata`, method: 'GET', payload: null }).then(function (result: any) {
                    // resolve handler
                    const { response } = result
                    const data = JSON.parse(response.replace('/', ''))
                    const userId = data ? data.userId : "";
                    sessionStorage.setItem("five9_agentId",userId)
                    // Fetching information for getepicuserid
                    if (userId) {
                        store.dispatch({
                            type: "one-state-getuserid/fetch",
                            payload: {
                                agentuserid: userId,

                            }
                        });
                    }
                    sessionStorage.setItem("five9_userid", userId);
                    //To fetch userName of Agent
                    interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${userId}`, method: 'GET', payload: null }).then(function (result: any) {
                    // resolve handler
                    const { response } = result
                    const data = JSON.parse(response.replace('/', ''))
                    console.log("Data for Agent--------",data)
                    const userName = data ? data.userName : "";
                    sessionStorage.setItem("agentName", userName ? userName : "");
                    }, function (error: any) {
                    // reject handler
                    log.debug('agents API error ', error);
                    });
                }, function (error: any) {
                    // reject handler
                    log.debug('Auth metadata error ', error);
                });
                // To fetch logout reason codes
                for (let loop:number = 1; loop <= 3; loop++) {
                    log.debug('Reason Codes Loop Count,', loop+"");
                    let data: any;
                    const promisevalue = new Promise((resolve, reject) => {
                        interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/orgs/${organizationId}/logout_reason_codes`, method: 'GET', payload: null }).then(function (result: any) {
                            // resolve handler
                            const { response } = result
                            data = JSON.parse(response.replace('/', ''))
                            // Fetching Logout Reason Codes and storing
                            if (data?.length > 0) {
                                store.dispatch({
                                    type: "store-five9-logout-codes",
                                    payload: {
                                        logoutCodes: data
                                    }
                                });
                            }
                            resolve(true)
                        }, function (error: any) {
                            // reject handler
                            log.debug('Logout Reason Codes error ', error);
                            resolve(false)
                        });
                    })
                    
                    if (promisevalue) {
                        log.debug('Reason Codes Loop break', 'successful');
                        break;
                    }
                }
            }
        });
        
        // 4 To observe active call is in TALKING or WRAP_UP state
        // 30 To observe active call is in OFFERED state
        // 5 To observe active call is in FINISHED state
        interactionApi.subscribeWsEvent({
            "4": function (params: any, context: any) {
                log.debug('subscribeWsEvent 4,', params)
                if(params?.state === 'TALKING' || params?.state === 'WRAP_UP'){
                    store.dispatch({
                        type: "store-five9-user-state",
                        payload: {
                            userSates : false
                        }
                    })
                    sessionStorage.setItem("five9_user_state", "false");
                }
            },
            "30": function (params: any, context: any) {
                log.debug('subscribeWsEvent 30,', params)
                if(params?.state === 'OFFERED'){
                    store.dispatch({
                        type: "store-five9-user-state",
                        payload: {
                            userSates : false
                        }
                    })
                    sessionStorage.setItem("five9_user_state", "false");
                }
            },
            "5": function (params: any, context: any) {
                log.debug('subscribeWsEvent 5,', params)
                if(params?.state === 'FINISHED'){
                    store.dispatch({
                        type: "store-five9-user-state",
                        payload: {
                            userSates : true
                        }
                    })
                    sessionStorage.setItem("five9_user_state", "true");
                }
            },
            "29": function (params: any, context: any) {
                if(context?.userName){
                    sessionStorage.setItem("agentName", context?.userName ? context?.userName : null);
                }
            }
            
        });

        interactionApi.subscribe({
            callStarted: async function (params: any) {
                console.log('Call Started - Agent')
                console.log(params);
                const { callType, interactionId } = params.callData;
                sessionStorage.setItem("CallInteractionId",interactionId)
                const cavList = await interactionApi.getCav({ interactionId });
                let stateobj = store.getState();
                const killnotification = stateobj?.five9Notification?.five9notification;
                const parkTime = cavList.find((cav: any) => cav.name === 'park_time')
                store.dispatch({
                    type: "one-state-five9_info/set",
                    payload: {
                        callid: params.callData.interactionId,
                        agentinfo: params.callData.agentId
                    }
                })
                store.dispatch({
                    type: "store-five9-details",
                    payload: true
                });
                let number;
                const sourceId = cavList.find((cav: any) => cav.name === 'sourceid')
                const subjectId = cavList.find((cav: any) => cav.name === 'subjectid')
                const aniNumber = cavList.find((cav: any) => cav.name === 'ANI')
                const skillName = cavList.find((cav: any) => cav.name === 'skill_name')
                const agentName = cavList.find((cav: any) => cav.name === 'user_name')
                const panviva_info = cavList.find((cav:any) => cav.name === 'panviva')
                if(panviva_info?.value) {
                    sessionStorage.setItem("five9_panvivaid",panviva_info.value);
                    }
                let dnis = cavList.find((cav: any) => cav.name === 'DNIS')?.value;
                if(Notification.permission === 'granted' &&
                 (callType === 'INBOUND' || callType === 'INTERNAL') &&
                 toaster_notification?.inbound_call_notification && 
                 killnotification){
                    Notify("Incoming Call ("+ aniNumber.value +")");
                }
                if(Notification.permission === 'granted' && callType === 'AGENT' && 
                  toaster_notification?.outbound_call_notification && 
                  killnotification){
                    Notify("Outgoing Call ("+ dnis +")");
                }

                let showVerificationModal: boolean = true;

                if (callType === 'INBOUND' || callType === 'INTERNAL') number = aniNumber.value

                if (callType === 'QUEUE_CALLBACK') number = params.callData.dnis
                if(callType === "AUTODIAL") number = dnis
                if(callType === "OUTBOUND") number = dnis
                //Stoping the Outbound call
                if(callType === 'AGENT') return;

                if (callType !== 'AGENT' && (sourceId || subjectId)) {
                    showVerificationModal = false;
                }

                if (parkTime?.value === "0" || 
                    parkTime?.value !== "0" && callType === 'INTERNAL') {
                       
                    //Reset the gadget before New Call.
                    store.dispatch({
                        type: "one-state-subject/reset",
                        payload: {
                            number: "",
                            dnis: ""
                        }
                    });  

                    // Store interactionId to redux
                    store.dispatch({
                        type: "interact-five9-set-interaction-id",
                        payload: interactionId,
                    });

                    let skeleton: {
                        source_skeleton: true,
                        subject_skeleton: true,
                        callingDestination_skeleton: true
                    }

                    store.dispatch({
                        type: "one-state-choosecaller/set",
                        payload: {
                            number,
                            dnis,
                            visible: showVerificationModal,
                            start: true
                        }
                    });

                    if (consolidated_api_invocation) {
                        store.dispatch({
                            type: "consolidated-api-one",
                            payload: {
                                number,
                                type: "Patient",
                                dnis,
                                subjectid: subjectId ? subjectId.value : null,
                                sourceid: sourceId ? sourceId.value : null,
                            }
                        });
                    } else {
                        store.dispatch({
                            type: "one-state-getsession/fetch",
                            payload: {
                                sessionKey:sourceId ? sourceId.value : null
                            }
                        });
                        if(panviva_cvsearch && panviva_info) {
                            let userinfo = sessionStorage.getItem('panvivauserinfo')
                            let agentinfo = agentName
                            if(panviva_sso === false) {
                                agentinfo = userinfo ? userinfo : ""
                            }
                            if(defaultcvsearch === "live_search") {
                                store.dispatch({
                                    type: "one-state-panviva/initiate",
                                    payload: {
                                        key:panviva_info.value,
                                        panviva_id: agentinfo,
                                        type: defaultcvsearch,
                                        id: "",
                                        location: ""
                                    }
                                })
                            }
                            else if(defaultcvsearch === "live_document") {
                                store.dispatch({
                                    type: "one-state-panviva/initiate",
                                    payload: {
                                        key:"",
                                        panviva_id: agentinfo,
                                        type: defaultcvsearch,
                                        id: panviva_info.value,
                                        location: ""
                                    }
                                })
                            }
                        }
                    }

                    //Dispostion Framework
                    let disp: Disposition = { value: "193" }
                    disp.dial_list_uid = interactionId;
                    disp.meta00 = agentName;
                    disp.meta01 = skillName?.value;
                    disp.meta02 = params?.callData?.sessionId;
                    disp.meta03 = params?.callData?.callType;
                    disp.meta04 = params?.callData?.ani;
                    disp.meta05 = 'client';
                    store.dispatch({
                        type: "store-disposition-code",
                        payload: disp
                    });

                    store.dispatch({
                        type: "one-state-skeleton/set",
                        payload: skeleton
                    });
                    sessionStorage.setItem("subjectid", subjectId ? subjectId.value : null);
                    sessionStorage.setItem("sourceid", sourceId ? sourceId.value : null);
                    sessionStorage.setItem("skillName", skillName?.value);
                    sessionStorage.setItem("ani", number);
                    sessionStorage.setItem("dnis", dnis);
                    sessionStorage.setItem("agentName", agentName ? agentName.value : null);

                    if (Notification.permission === 'granted' && callType === 'AGENT' &&
                        toaster_notification?.outbound_call_notification &&
                        toaster_notification?.outbound_call_epic_count_notification &&
                        killnotification) {
                        setTimeout(() => {
                            const patientcount = stateobj?.subjectstore?.values;
                            const count = (patientcount === undefined || patientcount === 'undefined' || patientcount === null) ? 0 : patientcount?.length;
                            Notify("Outgoing Call (" + dnis + ")          " + count + " Matches ");
                        }, 4000);
                    }
                    if (Notification.permission === 'granted' &&
                        (callType === 'INBOUND' || callType === 'INTERNAL') &&
                        toaster_notification?.inbound_call_notification &&
                        toaster_notification?.inbound_call_epic_count_notification &&
                        killnotification) {
                        setTimeout(() => {
                            const patientcount = stateobj?.subjectstore?.values;
                            const count = (patientcount === undefined || patientcount === 'undefined' || patientcount === null) ? 0 : patientcount?.length;
                            Notify("Incoming Call (" + aniNumber.value + ")     " + count + " Matches ");
                        }, 4000);
                    }
                }
            },
            callFinished: function (params: any) {
                console.log('Call Finished')
                console.log('___________________________________________________')
                console.log('___________________________________________________')
                console.log(params);
                //If retrieved the call from park then dont distpatch actions
                if (params?.reason === 'RETRIEVED') return;
                store.dispatch({
                    type: "one-state-subject/reset",
                    payload: {
                        number: '',
                        dnis: ''
                    }
                });

                store.dispatch({
                    type: "one-state-choosecaller/reset",
                    payload: {
                        number: '',
                        dnis: '',
                        visible: false,
                        start: false
                    }
                });
                store.dispatch({
                    type: "one-state-tabs/set",
                    payload: "1"
                })
                store.dispatch({
                    type: "interact-five9-reset",
                    payload: ""
                })
                store.dispatch({
                    type: "store-five9-clicktodial-reset",
                    payload: ""
                })
                store.dispatch({
                    type: "one-state-selectedsubject/reinit",
                })
                store.dispatch({
                    type: "one-state-selectedsource/reinit",
                })
                store.dispatch({
                    type: "one-state-five9_info/reinit",
                })
                store.dispatch({
                    type: "one-state-callertypeinfo/reinit"
                })
                sessionStorage.removeItem("subjectid");
                sessionStorage.removeItem("sourceid");
                sessionStorage.removeItem("ani");
                sessionStorage.removeItem("dnis");
                sessionStorage.removeItem("CallInteractionId")
                sessionStorage.removeItem("agentName");
                sessionStorage.removeItem("five9_panvivaid");
            },

            callAccepted: function (params: any) {
                console.log('Call Accepted')
                console.log('___________________________________________________')
                console.log('___________________________________________________')
                console.log(params);
                const { callType, interactionId } = params?.callData;
                if(callType === 'AGENT'){
                    store.dispatch({
                        type: "interact-five9-set-interaction-id",
                        payload: interactionId,
                    });
                }
                
            },

            callRejected: function (params: any) {
                console.log('Call Rejected')
                console.log('___________________________________________________')
                console.log('___________________________________________________')
                console.log(params);
            },

            callEnded: function (params: any) {
                console.log('Call Ended')
                console.log('___________________________________________________')
                console.log('___________________________________________________')
                console.log(params);
                //Dispostion Framework
                let disp: Disposition = { value: "178" }
                disp.dial_list_uid = params?.callData?.interactionId;
                disp.meta00 = params?.callData?.agent;
                disp.meta01 = "";
                disp.meta02 = params?.callData?.ani;
                disp.meta03 = "";
                disp.meta04 = 'client';
                store.dispatch({
                    type: "store-disposition-code",
                    payload: disp
                });
            },
        })
    })))

